import { Switch } from "@mui/material";

import styles from "./style.module.scss";

interface PermissionSwitchProps {
    id: string;
    label: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    nested?: boolean;
    disabled?: boolean;
}

const PermissionSwitch = ({
    id,
    label,
    checked,
    onChange,
    nested = false,
    disabled = false,
}: PermissionSwitchProps) => {
    return (
        <div className={`${styles["permission-switch"]} ${nested ? styles["nested"] : ""}`}>
            <label htmlFor={id} className={styles["label"]}>
                {label}
            </label>
            <Switch
                id={id}
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
                disabled={disabled}
                sx={{
                    width: 44,
                    height: 24,
                    padding: 0,
                    "& .MuiSwitch-switchBase": {
                        padding: 0,
                        margin: "2px",
                        transitionDuration: "300ms",
                        "&.Mui-checked": {
                            transform: "translateX(20px)",
                            color: "#fff",
                            "& + .MuiSwitch-track": {
                                backgroundColor: "#1c1c1c",
                                opacity: 1,
                                border: 0,
                            },
                        },
                    },
                    "& .MuiSwitch-thumb": {
                        boxSizing: "border-box",
                        width: 20,
                        height: 20,
                    },
                    "& .MuiSwitch-track": {
                        borderRadius: "13px",
                        backgroundColor: "#e9e9ea",
                        opacity: 1,
                    },
                }}
            />
        </div>
    );
};

export default PermissionSwitch;
